export default __webpack_public_path__ + "assets/pdf/PlattCreditApplication.3627d1c9.pdf";